import { sendGet } from 'hooks/use-fetch'
import { Typography, Box, Stack, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

export interface IntakeProviderDetails {
  name: string
  imageKey: string | null
  website: string | null
  contactEmail: string | null
  contactPhone: string | null
  primaryContactName: string | null
}

export interface DuplicateFoundProps {
  isdId: number
  type: 'provider' | 'caregiver'
  backPath?: string
}

export interface DuplicateContactInfo {
  name: string
  email?: string
  phone?: string
}

export function DuplicateFound (props: DuplicateFoundProps): JSX.Element {
  const [duplicateContact, setDuplicateContact] = useState<DuplicateContactInfo | null>()
  const nav = useNavigate()

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response: isdDetails } = await sendGet(`/ISDDetails/GetDetails?id=${props.isdId}`, {})
      const { response: mieccContact } = await sendGet('/SiteConfiguration/GetDuplicateHandlingContact', {})
      if (isdDetails?.duplicateContactName || isdDetails?.duplicateContactEmail) {
        setDuplicateContact({
          name: isdDetails.duplicateContactName,
          email: isdDetails.duplicateContactEmail,
          phone: isdDetails.duplicateContactPhone
        })
      } else if (mieccContact.name || mieccContact.email) {
        setDuplicateContact({
          name: mieccContact.name,
          email: mieccContact.email
        })
      } else {
        setDuplicateContact({ name: isdDetails.name })
      }
    }

    void fetchData()
  }, [])

  function goBack (): void {
    if (props.backPath != null) { nav(props.backPath) }
  }
  const displayText = props.type === 'caregiver'
    ? 'It seems like your child may already be in the MiECC system. Please enter the service and school year you are interested in and click Submit.' +
      ` By clicking submit, your request is sent to ${duplicateContact?.name ?? 'an ISD user'}. They will be in touch soon.`
    : 'It looks like your child may already be in the MiECC System. By clicking Submit Duplicate For Review below, an ISD User will review your request to work in this new record'
  return <>
    <Typography variant="h3" data-testid="page-header">
      Child Found
    </Typography>

    <Typography sx={{ mt: 2, mb: 2 }}>
      {displayText}
    </Typography>

    <Box className='CardDisplay' sx={{ width: 'max-content' }} >
      <Stack direction='column' spacing={1}>
        <Typography variant='h5'>
          Contact Information
        </Typography>
        <Stack direction='column'>
          <Typography>
            {duplicateContact?.name}
          </Typography>
          <Typography>
            {duplicateContact?.email}
          </Typography>
          {duplicateContact?.phone != null && (<Typography>
            {duplicateContact?.phone}
          </Typography>)}
        </Stack>
      </Stack>
    </Box>
    {props.backPath != null && (
      <Button variant='contained' color='primary' sx={{ mt: 2 }} onClick={goBack}>Go Back</Button>
    )}
  </>
}
